import { makeAutoObservable } from "mobx";

export default class PeopleModel {
  constructor() {
    makeAutoObservable(this);
  }

  id = "";
  name = "";
  family = "";
  email = "";
  phone = "";
  address = "";
  country = "";
  city = "";

  cities = [];
}
